import { createQrPaymentOrder } from '../../../redux/api/account'
import React, { useEffect } from "react";
import styled from "styled-components";
import { formatCurrency } from '../../../helpers/currency.format.helper'
import CheckIcon from '@material-ui/icons/Check';
import { Text } from "../../../components/common/Text";
import QRCode from "qrcode"
import PageLoading from '../../common/PageLoading'

function QrWalletPayment(props) {

    //props
    const { amount, clientId, gotoPage, setQrString, qrString, paymentOk, setPaymentOk } = props;

    //constantes
    const MS_TO_DISPLAY_SUCCESS_MSA = 8000;

    const generateQr = () => {
        QRCode.toCanvas(document.getElementById('canvas'),qrString)
    }

    const requestPaymentQr = async () => {
        const req = await createQrPaymentOrder({
            pos_qr_uuid:process.env.REACT_APP_PAY_QR_TERMINAL_UUID,
            amount:Number(amount),
            external_reference: clientId,
            description: 'payment request',

        })
        if (req.error) {
            alert('Ocurrio un error')
            return;
        }
        if (req[0]?.statusCode === 404) {
            setQrString(null);
            return
        }
        setQrString(req.qr_data)
    }

    useEffect(() => {
        requestPaymentQr();
    }, [])

    useEffect(() => {
        if(qrString){
            generateQr()
        }
    }, [qrString])

    if (paymentOk) {
        return (
            <Container>
                <Circle color="#66ba45"><CheckIcon /></Circle>
                <Text color="#333" fontSize="18px" fontWeight="bold">¡El pago se procesó con éxito!</Text>
            </Container>
        )
    }

    if (!qrString) {
        return <PageLoading w="100%" h="100px" />
    }

    return (
        <QrWrapper>
            <canvas id="canvas"></canvas>
            {
                amount &&  <TotalContainer>Total a pagar: ${formatCurrency(Number(amount).toFixed(2))}</TotalContainer>
            }
        </QrWrapper>
    )
}

export default QrWalletPayment;

const QrWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`
const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    margin: 18px 0;
`
const Circle = styled.div`
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: ${p => p.color};
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    svg{
        font-size: 48px;
    }
`
const TotalContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
`